import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ceap_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.startsWith("/login")
        && !window.location.pathname.startsWith("/tv")) {
      localStorage.removeItem("ceap_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export default api;

/** Iter 41: extrai mensagem de erro de qualquer resposta axios de forma segura.
 *  Pydantic 422 devolve `detail` como array de objetos — se passarmos direto ao
 *  toast/JSX, o React tenta renderizar objeto e crasha a tela (fica em branco).
 *  Sempre retornar uma STRING amigável. */
export function apiErrorMsg(err, fallback = "Erro inesperado") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    // Pydantic v2: [{loc: [...], msg: "...", type: "..."}]
    return d
      .map((e) => {
        if (typeof e === "string") return e;
        const loc = Array.isArray(e?.loc) ? e.loc.filter((x) => x !== "body").join(".") : "";
        return loc ? `${loc}: ${e?.msg || "inválido"}` : (e?.msg || "campo inválido");
      })
      .join(" · ");
  }
  if (d && typeof d === "object") {
    return d.msg || d.message || JSON.stringify(d);
  }
  return err?.message || fallback;
}

export function formatBRL(n) {
  const v = Number(n || 0);
  return v.toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });
}

export function formatBRLFull(n) {
  const v = Number(n || 0);
  return v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("pt-BR");
}

export function formatDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("pt-BR") + " " + d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
}

export function initials(name) {
  if (!name) return "?";
  return name.split(" ").filter(Boolean).slice(0, 2).map((s) => s[0].toUpperCase()).join("");
}

/** Converte avatar_url relativa (ex.: "/api/users/{id}/avatar?v=X") em URL absoluta usando BACKEND_URL. */
export function resolveAvatar(url) {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return BACKEND_URL + url;
  return url;
}

/** Retorna apenas dígitos do telefone e garante o DDI 55 (Brasil).
 *  Aceita entradas como "(48) 99999-8888" e devolve "5548999998888". */
export function cleanPhone(raw) {
  if (!raw) return "";
  const digits = String(raw).replace(/\D/g, "");
  if (!digits) return "";
  return digits.startsWith("55") ? digits : `55${digits}`;
}

/** URL do WhatsApp Web (desktop). Se não houver telefone válido, retorna null. */
export function whatsappHref(raw) {
  const d = cleanPhone(raw);
  return d ? `https://web.whatsapp.com/send?phone=${d}` : null;
}

export const TIPOS_ORGAO = [
  "Câmara", "Prefeitura", "Consórcio", "Assembleia Legislativa", "Tribunal de Contas",
  "Secretaria / Autarquia / Fundação", "Ministério Público / Defensoria", "Empresa / Órgão Federal", "Outro",
];

export const UFS = ["AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG","PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO"];

// Nome formal do órgão: "Câmara Municipal de X", "Consórcio X" ou o nome completo digitado
export function orgaoFormal(mun) {
  const t = mun?.tipo_orgao || "Câmara";
  const nome = mun?.nome || "";
  if (t === "Câmara" || t === "Prefeitura") return `${t} Municipal de ${nome}`;
  if (t === "Consórcio") return `Consórcio ${nome}`;
  return nome;
}

export const ESTAGIOS = [
  { key: "inscrito", label: "Inscritos" },
  { key: "certo", label: "Certos" },
  { key: "interessado", label: "Interessados" },
  { key: "incerto", label: "Incertos" },
  { key: "nao_querem", label: "Negativas" },
];
